// Google Analytics utility functions
export const GA_TRACKING_ID = 'G-HBB3L3C4D7';

// Track page views
export const trackPageView = (url, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: title,
      page_location: url,
    });
  }
};

// Track events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track search events
export const trackSearch = (searchTerm) => {
  trackEvent('search', 'engagement', searchTerm);
};

// Track article clicks
export const trackArticleClick = (articleTitle, category) => {
  trackEvent('article_click', 'engagement', articleTitle, category);
};